import {connect} from 'react-redux';
import AppBar from './app-bar';
import {logout} from '../../../../redux/actions/auth';

function mapStateToProps(state) {
	return state.auth;
}

function mapDispatchToProps(dispatch) {
	return {
		signOut() {
			dispatch(logout());
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(AppBar);



// WEBPACK FOOTER //
// ./src/client/components/admin/layout/app-bar/index.js